import {
  IGetStockBalancesDTO,
  IGetStockBalancesResponse,
  IGetStockCategoriesResponse,
  IGetStockRegionsResponse,
  StockBalancesEndpoints,
} from '@/models/stockBalances.model';
import { ApiResponse, httpClient } from '@/utils';

class StockBalancesAPI {
  static getStockBalances(data: IGetStockBalancesDTO): ApiResponse<IGetStockBalancesResponse> {
    return httpClient.get<IGetStockBalancesResponse>(StockBalancesEndpoints.STOCK_BALANCES, { params: data });
  }

  static getStockRegions(): ApiResponse<IGetStockRegionsResponse> {
    return httpClient.get<IGetStockRegionsResponse>(StockBalancesEndpoints.STOCK_BALANCES_REGIONS);
  }

  static getStockCategories(): ApiResponse<IGetStockCategoriesResponse> {
    return httpClient.get<IGetStockCategoriesResponse>(StockBalancesEndpoints.STOCK_BALANCES_CATEGORIES);
  }
}

export default StockBalancesAPI;
